export const actionTypes = {
  GET_CHARTSETTINGS: "chartSettings/getChartSettings",
  PUT_CHARTSETTINGS: "chartSettings/putChartSettings",
};
